import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";

const CalendarDemo = (props: any) => {
  let today = new Date();

  // Calculate the end date as 6 days before the current day
  const sixDaysAgo = new Date(today);
  sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);

  // Initialize the date range as an array containing the start and end dates
  const [dateRange, setDateRange] = useState<Date[] | undefined>([
    sixDaysAgo,
    today,
  ]);

  addLocale("es", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Claro",
  });

  const dateTemplate = (date: any) => {
    if (date.day > 10 && date.day < 15) {
      return (
        <strong style={{ textDecoration: "line-through" }}>{date.day}</strong>
      );
    }

    return date.day;
  };

  const handleDateSelect = (e: any) => {
    // Handle the selected date range
      setDateRange(e.value);
      if (props.SuscribedChange) props.SuscribedChange(e.value);
  };

  return (
    <div className="calendar-main">
      <div className="field col-12 md:col-4">
        <Calendar
          id="range"
          value={dateRange}
          selectionMode="range"
          readOnlyInput
          dateFormat="dd/mm/yy" // Set the desired date format
          onChange={handleDateSelect}
        />
      </div>
    </div>
  );
};

export default CalendarDemo;
